import { Input } from 'antd';
import type { ChangeEvent, FocusEvent } from 'react';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
}

// Strip non-digits, cap at 8 (DDMMYYYY), insert '/' after positions 2 and 4.
// "25" → "25" | "257" → "25/7" | "25072000" → "25/07/2000".
function applyDateMask(input: string): string {
  const raw = input.replace(/\D/g, '').slice(0, 8);
  if (raw.length >= 5) return `${raw.slice(0, 2)}/${raw.slice(2, 4)}/${raw.slice(4)}`;
  if (raw.length >= 3) return `${raw.slice(0, 2)}/${raw.slice(2)}`;
  return raw;
}

export function DateMaskInput({ value, onChange, onFocus, onBlur }: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(applyDateMask(e.target.value));
  };
  return (
    <Input
      value={value ?? ''}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder="DD/MM/YYYY"
      maxLength={10}
      inputMode="numeric"
    />
  );
}
